import styled from 'styled-components'
import { theme } from '../../theme/theme'

export const MachineFiltersHolder = styled.div`
  margin: ${theme.space.md} 0;
`
